module.exports = __webpack_public_path__ + "img/f1fcb09.png";